@if (item) {
  @if (!contentEdit) {
    <coin-v2-button
      iconPos="right"
      [type]="$any(item.style)"
      [icon]="item.icon"
      [text]="item.text"
      (click)="openPage(item['link'])"></coin-v2-button>
  }

  @if (contentEdit) {
    <div style="display: flex; flex-direction: column; width: 100%; gap: 1rem">
      <coin-v2-button
        iconPos="right"
        [type]="$any(item.style)"
        [icon]="item.icon"
        [text]="item.text"
        (click)="openPage(item['link'])"></coin-v2-button>

      <coin-v2-text-input
        [label]="'cms.button-text' | translate"
        [placeholder]="'cms.button-text-placeholder' | translate"
        [disabled]="!contentEdit"
        [(ngModel)]="item['text']" />

      <coin-v2-text-input
        [label]="'cms.button-link' | translate"
        [placeholder]="'cms.button-text-placeholder' | translate"
        [disabled]="!contentEdit"
        [(ngModel)]="item['link']" />

      <mat-form-field appearance="fill">
        <mat-label>{{ 'cms.button-style' | translate }}</mat-label>
        <mat-select [(ngModel)]="item.style">
          @for (option of buttonStyles; track option) {
            <mat-option [value]="option">{{ option | titlecase }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'cms.button-icon' | translate }}</mat-label>
        <mat-select [(ngModel)]="item.icon">
          @for (option of buttonIcons; track option) {
            <mat-option [value]="option">{{ buttonDisplayFn(option) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
}
